module.exports = __webpack_public_path__ + "static/access-48d117a15ebe3c6eeb2da9e7d292ac99.png";